import { useQuery } from '@tanstack/react-query'
import { getPatientReservations } from 'services/reservation/getPatientReservations'
import { PATIENT_HOME } from 'settings/_reactQueryConstants'

interface UseGetPatientReservations {
  quantityOfRecurrentReservations: number
  reservationProfessionalUsername: string
  isLoading: boolean
}

export const useGetPatientReservations = (patientUsername: string): UseGetPatientReservations => {
  const { data, isLoading } = useQuery({
    queryKey: [PATIENT_HOME.RESERVATION_SPECIALTY_SELECTOR, patientUsername],
    queryFn: () => getPatientReservations(patientUsername),
    enabled: !!patientUsername
  })

  if (!data || isLoading) {
    return {
      quantityOfRecurrentReservations: 0,
      reservationProfessionalUsername: '',
      isLoading
    }
  }
  
  const quantityOfRecurrentReservations = data.reservations
    .filter(reservation => reservation.recurrence === 'Semanal')?.length

  const reservationProfessionalUsername = data.reservations[0].professional_username

  return {
    quantityOfRecurrentReservations,
    reservationProfessionalUsername,
    isLoading
  }
}